import { useFormikContext } from 'formik';
import React from 'react';

import Form from 'react-bootstrap/Form';
import { catalogFormInitialValues } from '../../modules/catalog-form/catalog-form.form';

type Option = { value: string; label: string }

type SelectProps = {
    name: keyof typeof catalogFormInitialValues;
    isDisabled?: boolean;
    isInvalid?: boolean;
    options: Option[];
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const Select: React.FC<SelectProps> = ({
    name,
    isDisabled,
    isInvalid,
    options,
    onChange,
}) => {
    const { values, setFieldValue } = useFormikContext<typeof catalogFormInitialValues>();

    return (
        <Form.Select
            value={values[name] || ''}
            onChange={(event) => {
                setFieldValue(name, event.target.value);
                onChange?.(event);
            }}
            disabled={isDisabled}
            isInvalid={isInvalid}
        >
            <option>Wybierz z listy</option>
            {options.map((option) => (
                <option value={option.value}>{option.label}</option>
            ))}
        </Form.Select>
    )
}